import { Component, Fragment } from "react";
import { App } from "./App";
import useServerError from "/src/routes/errors/serverError/useServerError";

export class Root extends Component<any, any> {
  componentDidCatch(_error: any, _errorInfo: any) {
    // @ts-ignore
    useServerError.setState({ error: { message: "", response: { status: 500 } } });
  }

  static getDerivedStateFromError(_error: any): Partial<any> {
    return { hasError: true };
  }

  render() {
    return (
      <Fragment>
        <App />
      </Fragment>
    );
  }
}
